// START GENAI@CHATGPT4
import { ZodIssue } from 'zod';
//START GENAI@CHATGPT4
import { error, invalidParam } from 'common/errors';
// eslint-disable-next-line import/no-restricted-paths
import getCards from 'orch-communicator/external/get-cards';
import { GetCardsInput } from 'types/vsb-sdk/get-cards';
import { ConsumerIdentityModel } from 'vsb-sdk/schemas/consumer-identity';
import pushEvents from './push-events';

// START GENAI@CHATGPT4
/**
 * START GENAI@GHCOPILOT
 * Validates the input for the getCards API.
 * @param rawInput The raw input for the getCards API.
 * @returns The validated input for the getCards API.
 * END GENAI@GHCOPILOT
 */
function validateGetCards(rawInput: GetCardsInput) {
  const rawConsumerIdentity = rawInput.consumerIdentity;
  //START GENAI@CHATGPT4
  //START GENAI@COPILOT
  //START GENAI@GHCOPILOT

  if (typeof rawConsumerIdentity !== 'object') {
    return {
      actionCode: 'ERROR',
      profiles: [],
      error: error(
        'CONSUMER_ID_MISSING',
        `The "consumerIdentity" parameter is missing.`,
        ' ' as unknown as ZodIssue[]
      ).error
    };
  }

  const result = ConsumerIdentityModel.safeParse(rawConsumerIdentity);

  if (!result.success) {
    const { issues } = result.error;

    if (issues.some(issue => issue.path.includes('identityProvider'))) {
      return {
        actionCode: 'ERROR',
        profiles: [],
        error: error(
          'INVALID_PARAMETER',
          `Invalid consumer identity.`,
          ' ' as unknown as ZodIssue[]
        ).error
      };
    }

    if (issues.some(issue => issue.path.includes('identityType'))) {
      return {
        actionCode: 'ERROR',
        profiles: [],
        error: error(
          'INVALID_PARAMETER',
          `Invalid consumer identity.`,
          ' ' as unknown as ZodIssue[]
        ).error
      };
    }

    //START GENAI@CHATGPT4
    const errorMapping: { [key: string]: string } = {
      '"identityValue" must not be null': 'CONSUMER_ID_MISSING',
      '"identityValue" must be a valid email address': 'CONSUMER_ID_FORMAT_UNSUPPORTED',
      '"identityValue" must not be empty': 'CONSUMER_ID_FORMAT_UNSUPPORTED'
    };

    if (issues.some(issue => issue.path.includes('identityValue'))) {
      const firstIssueMessage = issues[0].message;

      if (firstIssueMessage in errorMapping) {
        return {
          actionCode: 'ERROR',
          profiles: [],
          error: error(
            errorMapping[firstIssueMessage],
            `Invalid consumer identity.`,
            issues[0] as unknown as ZodIssue[]
          ).error
        };
      }
    }

    return {
      actionCode: 'ERROR',
      profiles: [],
      error: invalidParam(issues).error
    };
  }
  //END GENAI@CHATGPT4
  //END GENAI@COPILOT

  return result.data;
}

export default async (rawInput: GetCardsInput) => {
  //eslint-disable-next-line
  console.log('getCardsInput', rawInput);

  const validatedConsumerIdentity = validateGetCards(rawInput);

  /**
   * START GENAI@GHCOPILOT
   * If 'validationData' is present in the input, validate it.
   * END GENAI@GHCOPILOT
   */
  //START GENAI@COPILOT
  if ('validationData' in rawInput) {
    if (typeof rawInput.validationData !== 'string' || rawInput.validationData.trim() === '') {
      return {
        actionCode: 'ERROR',
        profiles: [],
        error: error('VALIDATION_DATA_MISSING', 'The "ValidationData" paramter is missing', [
          {
            message: 'Validation data should be a non empty string.',
            path: 'validationData'
          }
        ] as unknown as ZodIssue[]).error
      };
    }
  }
  //END GENAI@COPILOT

  if (
    'actionCode' in validatedConsumerIdentity &&
    validatedConsumerIdentity.actionCode === 'ERROR'
  ) {
    return validatedConsumerIdentity;
  }
  //END GENAI@CHATGPT4

  //START GENAI@GHCOPILOT
  //START GENAI@GHCOPILOT
  //eslint-disable-next-line
  const response: any = await getCards(rawInput);

  if ('error' in response) {
    //eslint-disable-next-line
    if ((response.error as any).reason === 'ADD_CARD') {
      /* START GENAI@GHCOPILOT */
      const step = `VSB_GET_CARDS_API_FAILED_RESPONSE`;
      pushEvents({
        E: step,
        CO: 'VSB_SDK_V2'
      });
      /* END GENAI@GHCOPILOT */

      return {
        actionCode: 'ADD_CARD',
        profiles: [],
        //@ts-ignore
        error: response.error
      };
    }
    //END GENAI@GHCOPILOT
    //START GENAI@CHATGPT4

    return {
      actionCode: 'ERROR',
      profiles: [],
      //@ts-ignore
      error: response.error
    };
  }
  //END GENAI@GHCOPILOT

  /* START GENAI@GHCOPILOT */
  if (response.value?.profiles?.length > 0) {
    /* START GENAI@GHCOPILOT */
    const step = `VSB_GET_CARDS_API_SUCCESS_RESPONSE`;
    pushEvents({
      E: step,
      CO: 'VSB_SDK_V2'
    });
    /* END GENAI@GHCOPILOT */
  }
  /* END GENAI@GHCOPILOT */

  return response;
};
//END GENAI@GHCOPILOT
